let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ghoVB")).then(() => parcelRequire('3ku7m'));